import React, { useEffect } from 'react';
import { useAgentStore } from '@/stores/agentStore';

export const AgentIndicator: React.FC = () => {
  const { agents, currentAgentId, loadAgents } = useAgentStore();

  useEffect(() => {
    if (agents.length === 0) {
      loadAgents();
    }
  }, [agents.length, loadAgents]);

  const currentAgent = agents.find((a) => a.id === currentAgentId);

  if (agents.length === 0) return null;

  return (
    <div className="flex items-center gap-1.5 px-2.5 py-1 text-xs text-gray-300 bg-white/5 rounded-md">
      <span className="text-sm">{currentAgent?.avatar || '🧭'}</span>
      <span>{currentAgent?.name || '调度中心'}</span>
      <div
        className="w-2 h-2 rounded-full"
        style={{ backgroundColor: currentAgent?.color || '#6366f1' }}
      />
    </div>
  );
};
